import {
    HttpEvent, HttpHandler, HttpInterceptor,
    HttpRequest, HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    BOOKING_EP, PROPOSALS_EP, RATES_EP, RERATING_EP
} from '@app/shared/constants/globalConstants';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class InsuranceInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let clonedRequest = req;

        // This applies for endpoints that have `/rates` or `/proposals` or `/rerating` in them
        if (req.body && typeof req.body === 'object') {
            if (
                (req.url.toLowerCase().includes(RATES_EP) ||
                req.url.toLowerCase().includes(PROPOSALS_EP) ||
                req.url.toLowerCase().includes(RERATING_EP)) &&
                'loanData' in req.body
            ) {
                const modifiedBody = {
                    ...req.body,
                    loanData: {
                        ...req.body.loanData,
                        insuranceCompany: req.body.loanData.insName,
                        agentName: req.body.loanData.insAgent,
                        agentPhone: req.body.loanData.insAgentPhone,
                        insurancePolicyNumber: req.body.loanData.insPolicyNumber
                    }
                };
                clonedRequest = req.clone({ body: modifiedBody });
            }
        }

        return next.handle(clonedRequest).pipe(
            map((event: HttpEvent<any>) => {
                // This applies only for response of `/proposals` and `/bookings`
                if (
                    event instanceof HttpResponse &&
                    (event.url?.toLowerCase().includes(PROPOSALS_EP) ||
                        event.url?.toLowerCase().includes(BOOKING_EP)) &&
                    event.body &&
                    typeof event.body === 'object' &&
                    'loanData' in event.body
                ) {
                    const modifiedBody = {
                        ...event.body,
                        loanData: {
                            ...event.body.loanData,
                            insName: event.body.loanData.insuranceCompany,
                            insAgent: event.body.loanData.agentName,
                            insAgentPhone: event.body.loanData.agentPhone,
                            insPolicyNumber: event.body.loanData.insurancePolicyNumber
                        }
                    };
                    return event.clone({ body: modifiedBody });
                }
                return event;
            })
        );
    }
}
